import { render, staticRenderFns } from "./njwxDia.vue?vue&type=template&id=06d9b250&scoped=true&"
import script from "./njwxDia.vue?vue&type=script&lang=js&"
export * from "./njwxDia.vue?vue&type=script&lang=js&"
import style0 from "./njwxDia.vue?vue&type=style&index=0&id=06d9b250&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d9b250",
  null
  
)

export default component.exports